import styled from "styled-components";

const MainContainer = styled.main`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default MainContainer;
